"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Like(_a) {
    var video = _a.video, user = _a.user, likes = _a.likes, userLike = _a.userLike;
    var _b = react_1.useState(Boolean(userLike)), liked = _b[0], setLiked = _b[1];
    var _c = ra_fetch_1.useApi('media')
        .store('likes', {
        user_id: user.id,
        video_id: video.external_id,
    }), like = _c[0], setLike = _c[1], submitLike = _c[2];
    function onSubmit() {
        if (!user.id) {
            window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login?return=/videos/" + video.slug;
            return;
        }
        if (!liked) {
            submitLike().then(function (res) {
                if (res.errors.length === 0) {
                    setLiked(true);
                }
            });
        }
    }
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-likes-wrapper flex items-center', liked ? '' : 'cursor-pointer'), onClick: onSubmit },
        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'heart', className: "mr-2 " + (liked ? 'fill-like' : '') }),
        react_1.default.createElement("strong", null, !userLike && liked ? likes + 1 : likes));
}
function Create(_a) {
    var video = _a.video, user = _a.user;
    var _b = ra_fetch_1.useApi('media').show('likes.count', {
        video_id: video.external_id,
        paginate: 1,
        sort: 'created_at desc',
    }), likes = _b[0], setLikes = _b[1], likeParams = _b[2], setLikeParams = _b[3];
    var _c = ra_fetch_1.useApi('media').show('likes.count', {
        user_id: user.id,
        video_id: video.external_id,
    }), userLike = _c[0], setUserLikes = _c[1], userLikeParams = _c[2], setUserLikeParams = _c[3];
    react_1.useEffect(function () {
        if (video.external_id !== likeParams.external_id) {
            setLikeParams(__assign(__assign({}, likeParams), { video_id: video.external_id }));
            setUserLikeParams(__assign(__assign({}, userLikeParams), { video_id: video.external_id }));
        }
    }, [video.external_id]);
    if (likes.loading || userLike.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-likes' },
        react_1.default.createElement(Like, { video: video, user: user, userLike: userLike.data.count, likes: likes.data.count }));
}
exports.default = Create;
